export default "__VITE_ASSET__C57wA_si__"